@if (isInitializing()) {
  <div
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-[#dce4ec]">
    <img
      src="assets/login-logo.svg"
      alt="Valley Check Pivot"
      class="logo-pulse w-52" />
  </div>
}

<router-outlet />
